import React, { useEffect, useState } from 'react';
import { Constants } from '@shared';

function CommunityLogo(props) {

    const domainToUrl = () => {
        const [subDomain] = window.location.hostname.split(`.`);
        return `${Constants.ImgBucket}/${subDomain}.png`;
    };

    const [imageUrl, setImageUrl] = useState(domainToUrl());
    useEffect(() => {
        // Watch out for changing subdomain...
        setImageUrl(domainToUrl());
    }, [window.location.hostname]);

    return (
        <div {...props}>
            <img src={imageUrl} className="h-20 mr-3" />
            <img src={`${Constants.ImgBucket}/powered-by-sunbound.svg`} className="h-8" />
        </div>
    );
}

export default CommunityLogo;
